var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"color":"#111","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',{staticClass:"tooltip-icon"},[_c('i',_vm._g({staticClass:"fa fa-question-circle"},on))])]}}])},[_c('div',{staticClass:"tooltip-body"},[_c('p',[_vm._v("The number of channels in the audio media")])])])}
var staticRenderFns = []

export { render, staticRenderFns }